import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { UnarchiveBundleDialog } from '@/features/admin/bundle/UnarchiveBundleDialog'
import { type UnarchiveBundleDialogViewModel } from './UnarchiveBundleDialogViewModel'

export interface UnarchiveBundleDialogContainerProps {
  vm: UnarchiveBundleDialogViewModel
}

export const UnarchiveBundleDialogContainer = observer(
  function UnarchiveBundleDialogContainer({
    vm,
  }: UnarchiveBundleDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))

    return (
      <UnarchiveBundleDialog
        showing={vm.modal.showing}
        onClose={vm.cancel}
        onUnarchive={vm.unarchive}
        isUnarchivePending={vm.unarchive.pending}
        bundleName={vm.bundle.name}
        corporateMode={shellInfo.corporateMode}
        testId="bundle"
      />
    )
  },
)
